import { render } from "./HaircolorTreatPopup.vue?vue&type=template&id=cc573e38"
import script from "./HaircolorTreatPopup.vue?vue&type=script&lang=js"
export * from "./HaircolorTreatPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__